const fr = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Viens vite apprendre <br />le chinois sur SuperChinese avec moi !',
	'零基础任性学': 'Vous pouvez apprendre à partir de zéro',
	'听说读写全面提升': "Amélioration de l'écoute, de l'expression orale, de la lecture et de l'écriture",
	'趣味对话': 'Dialogues amusants',
	'100+日常对话等你来': 'Plus de 100 conversations quotidiennes vous attendent',
	'智能AI': "Capacité d'Intelligence Artificielle",
	'个性化学习推荐，由浅入深系统学': "Recommandation d'apprentissage personnalisée, apprentissage systématique de connaissances superficielles à profondes",
	'趣味对话等你来': 'Un dialogue amusant vous attend',
	'立即打开': 'Ouvrez maintenant',
	'我在SuperChinese<br />已累计学习{day}天': "Avec SuperChinese<br />J'apprends depuis <span>{day}</span> jours",
	'我在SuperChinese<br />已连续学习{day}天': "Avec SuperChinese<br />J'ai appris pendant <span>{day}</span> jours d'affilée",
	'学习生词': 'Apprendre des nouveaux mots',
	'学习语法': 'Apprendre la grammaire',
	'口语练习': "Pratiquer l'oral",
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>fois',
	'点击右上角的按钮,选择在浏览器中打开': "Cliquez sur le bouton en haut à droite,Choisissez de l'ouvrir dans le navigateur.",
	'邀请码': 'Code d\'invitation',
	'用邀请码注册，参与抽大奖': 'Les nouveaux utilisateurs sont invités à s\'inscrire et à remplir le Code d\'invitation pour participer au tirage au sort.',
}
export default fr;